import { Link, useParams } from "react-router";
import { useEffect, useState } from "react";
import Loader from "@app/icons/Loader";
import PostCard from "@app/components/PostCard";
import { PostResponse } from "@api/src/types/responses";

export default function Post() {
  const { postId } = useParams();

  const [post, setPost] = useState<PostResponse["data"]["post"] | null>(null);

  useEffect(() => {
    fetch(`${import.meta.env.VITE_API_URL}/post/${postId}`, {
      credentials: "include",
    })
      .then((res) => res.json() as Promise<PostResponse>)
      .then((response) => {
        if (response.error) {
          alert(response.error);
          return;
        }
        setPost(response.data.post);
      });
  }, [postId]);

  if (!post) return <Loader />;

  return (
    <main className="relative mt-4 flex w-full flex-col overflow-y-auto md:px-6">
      <div className="flex w-full flex-col items-start justify-between px-2">
        <div className="flex items-center">
          <Link
            to={`/?qRoomType=${post.room.roomType}&qRoomId=${post.roomId}`}
            className="w-max cursor-pointer py-1 text-xs text-sky-900"
          >
            Aller dans le canal
          </Link>
        </div>
      </div>
      <PostCard post={post} showRoomName />
    </main>
  );
}
